import { render, staticRenderFns } from "./HT_groupaccident.vue?vue&type=template&id=abb9a522&scoped=true"
import script from "./HT_groupaccident.vue?vue&type=script&lang=js"
export * from "./HT_groupaccident.vue?vue&type=script&lang=js"
import style0 from "./HT_groupaccident.vue?vue&type=style&index=0&id=abb9a522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.23_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_t2asupwbbn4g4z6gf7kzzdxifm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb9a522",
  null
  
)

export default component.exports